<script>
    import { currentUser } from '$lib/Auth';
    import { onDestroy } from 'svelte';

    /**
     * @typedef {Object} Props
     * @property {string} [as]
     * @property {boolean} [noAriaRole]
     */
    let { as = 'li', noAriaRole = false } = $props();

    let userAvatar = $state('/ui/account_default.svg');
    let userName = $state();
    let userEmail = $state();
    let userID = $state();

    const unsubscribeUser = currentUser.subscribe((u) => {
        if (u) {
            userName = getUserDisplayName(u);
            userEmail = u?.systemData?.email || u?.email || '[No Email]';
            userID = u.uid;
            if (u.providerData && u.providerData.length > 0) {
                userAvatar =
                    u.providerData[0].photoURL || '/ui/account_default.svg';
            } else {
                userAvatar = u?.systemData?.photoURL || u?.photoURL || '/ui/account_default.svg';
            }
        }
    });

    function getUserDisplayName(userData) {
        if (userData.providerData && userData.providerData.length > 0) {
            const providerData = userData.providerData[0];
            const systemData = userData.systemData;
            if (
                providerData.displayName &&
                providerData.displayName.indexOf('{') === 0
            ) {
                try {
                    const parsed = JSON.parse(providerData.displayName);
                    if (parsed && parsed.first && parsed.last) {
                        return parsed.first + ' ' + parsed.last;
                    }
                } catch (e) {
                    console.error(e);
                }
            } else if (systemData?.displayName) {
                return systemData.displayName;
            }

            if (providerData.email) {
                return providerData.email;
            }
        }

        return (
            userData.systemData?.displayName ||
            userData.systemData?.email ||
            userData.displayName ||
            userData.email ||
            'User'
        );
    }

    onDestroy(() => {
        [unsubscribeUser].forEach((u) => {
            try {
                u();
            } catch (e) {
                console.error(e);
            }
        });
    });
</script>

<svelte:element
    this={as}
    class="floating-menu-row semi-interactive"
    title="ID:{userID}"
    role={noAriaRole ? null : 'presentation'}
>
    <div class="row">
        <img
            class="avatar"
            src={userAvatar}
            alt={`${userName} profile image`}
        />
        <h2 class="username">{userName}</h2>
    </div>
    <span class="email">{userEmail}</span>
</svelte:element>

<style>
    .row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .floating-menu-row {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        max-width: 20rem;
        color: #262424;
        background-color: rgb(255, 206, 44);
        overflow: hidden;
    }

    .avatar {
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 0.25rem;
        margin: 0.5rem 0.5rem 0.5rem 0.75rem;
        color: inherit;
    }

    .username {
        margin: 0 1rem 0 0;
        color: inherit;
        flex-shrink: 0;
        text-transform: capitalize;
    }

    .email {
        margin: 0 1rem 0.5rem 1rem;
        color: inherit;
        flex-shrink: 0;
        font-size: 0.85rem;
    }
</style>
